module.exports = __webpack_public_path__ + "img/solution7.5d281459.png";